import { useCheckoutState, useIsAfterpayAppGiftCardFlow, useCountry } from '../../state'
import { CheckoutStatus } from '../../model'
import { Route } from '../../config/router'
import { useIsRoute } from '../../state/hooks'
import { Country } from '@afterpaytouch/portal-api/types'

export const useHideFooterForUSLoginPage = (): boolean => {
  const isLoginRoute = useIsRoute(Route.ENTER_EMAIL)
  const country = useCountry()

  return isLoginRoute && country === Country.US
}

export const useAllowClose = (allowClose: boolean): boolean => {
  const { status } = useCheckoutState()
  const isAfterpayAppGiftCardFlow = useIsAfterpayAppGiftCardFlow()
  const isPurchaseSuccessRoute = useIsRoute(Route.PURCHASE_SUCCESS)

  const isNotConfirmingOrConfirmed = status !== CheckoutStatus.Confirming && status !== CheckoutStatus.Confirmed
  const shouldAllowClose = isNotConfirmingOrConfirmed && !isAfterpayAppGiftCardFlow

  return allowClose && (shouldAllowClose || isPurchaseSuccessRoute)
}
